import { AppNotificationDto } from '@act/shared/data-transfer-objects';
import CheckIcon from '@mui/icons-material/Check';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { CardHeader, Typography } from '@mui/material';
import { Fragment } from 'react';
import { useAppNavigation } from 'react-components/app/routing/routes';
import { appNotificationRequests } from 'redux/requests/app-notification.requests';
import { useApiCall } from 'redux/utils/api-hook';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';

import './notification.styles.scss';

interface NotificationContentProps {
  notification: AppNotificationDto;
  groupKey: string;
  onNotificationClick?: () => void;
}

const NOTIFICATION_ICON_MAP = {
  'member-assignment': <PersonAddOutlinedIcon />,
  'back-on-plan': <CheckCircleOutlinedIcon />,
  task: <TaskAltOutlinedIcon />,
  approval: <SwapHorizIcon />,
  'for-review': <PhoneForwardedOutlinedIcon />,
  default: <QuestionMarkOutlinedIcon />,
};

const NotificationContent = ({
  notification,
  groupKey,
  onNotificationClick,
}: NotificationContentProps) => {
  const navigate = useAppNavigation();
  const [
    _markAppNotificationsAsSeenResponse,
    _isMarkingAllAsSeen,
    markAppNotificationsAsSeen,
  ] = useApiCall(appNotificationRequests.markAppNotificationsAsSeen);

  function getAvatar(groupKey: string) {
    return NOTIFICATION_ICON_MAP[groupKey] || NOTIFICATION_ICON_MAP['default'];
  }

  function updateSeenAt(event) {
    event.stopPropagation();
    markAppNotificationsAsSeen({
      body: {
        notificationIds: [notification?.id],
        seen: notification?.seenAt ? false : true,
      },
      params: null,
    });
  }

  function handleClick() {
    if (groupKey === 'for-review') {
      navigate.toCalls({ onlyUnassignedCalls: true });
    } else if (notification.memberId) {
      navigate.toMemberPage(notification.guideId, notification.memberId);
    } else {
      navigate.toMemberList();
    }
    onNotificationClick?.();
  }

  return (
    <CardHeader
      className="notification-header"
      avatar={getAvatar(groupKey)}
      title={
        <Fragment>
          <div className="notification-header__title">
            <Typography variant="titleMedium">{notification.label}</Typography>
            {!notification.seenAt && (
              <div
                className="title__seen-at-marker title__status-button"
                onClick={updateSeenAt}
              ></div>
            )}
            {!!notification.seenAt && (
              <CheckIcon
                className="title__status-button"
                onClick={updateSeenAt}
              />
            )}
          </div>
        </Fragment>
      }
      subheader={
        <Typography variant="bodyMedium">{notification.description}</Typography>
      }
      sx={{
        padding: '12px 0 12px',

        '.MuiCardHeader-avatar': {
          display: 'grid',
          placeItems: 'center',
          height: '48px',
          width: '48px',
          backgroundColor: '#dce4e8',
          borderRadius: '50%',
        },
      }}
      onClick={handleClick}
    ></CardHeader>
  );
};

export default NotificationContent;
